<template>
    <div id="app">
        <pageLoader :showLoader = 'showLoader' :checkDocState=true></pageLoader>
        <div class="error_modal" v-if="messageModalModel">
            <div @click="messageModalModel = null" class="close">
                <img alt="Close" src="@/assets/icons/ic_close_white.svg">
            </div>
            <div class="body">{{messageModalModel.text}}</div>
        </div>
        <customModalDialog v-if="getOriginalCredentials" :settings="customModalSettings"></customModalDialog>

        <main id="page-wrap">
            <router-view/>
            <button @click="onReturnToOriginalAccount"
                    class="return-to-original-account"
                    v-if="getOriginalCredentials">
                <div>
                    <i class="fas fa-sign-in-alt"></i>
                    <span class="text">{{translate(`admin_ReturnToOriginalAccount`, [getOriginalCredentials.name])}}</span>
                </div>
            </button>
        </main>
        <div class="change_language" v-if="!accessToken && this.$route.name !== 'Login'">
            <languageSwitcher></languageSwitcher>
        </div>
    </div>
</template>

<script>
    import logAnalyticsEvent from "@/helpers/analytics";

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    import '@/assets/css/buttons.css'

    import Vue from 'vue'
    import 'bootstrap/dist/css/bootstrap.css'
    import 'bootstrap-vue/dist/bootstrap-vue.css'
    import GAuth from 'vue-google-oauth2'
    // import facebookLogin from 'facebook-login-vuejs';
    import {VFBLogin as VFacebookLogin} from 'vue-facebook-login-component'

    import axios from 'axios';
    import api from '@/api';
    import GmapCustomMarker from 'vue2-gmap-custom-marker';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import config from '@/api/config';
    //
    import languageSwitcher from '@/components/widgets/languageSwitcher'
    import customModalDialog from '@/components/widgets/customModalDialog';
    import pageLoader from "@/components/widgets/pageLoader";

    const gauthOption = {
        clientId: '476870467397-vdhi2d5l3sn458mesgpvrg47cugdjgbf.apps.googleusercontent.com',
        scope: 'profile email',
        prompt: 'select_account'
    };

    Vue.use(GAuth, gauthOption)

    export default {
        name: 'app',

        data() {
            return {
                messageModalModel: null,
                customModalSettings: {},
                loaderTags: [],
                showLoader: false
                // showNav: true,
                // handleCloseMenu: false,
            }
        },
        computed: {
            ...mapState({
                accessToken: state => state.auth.accessToken,
                messageModel: state => state.messageModel,
                loaderBarTag: state => state.progressBarTag
            }),
            ...mapGetters({
                getOriginalCredentials: 'auth/getOriginalCredentials',
            }),
        },
        watch: {
            messageModel(item) {
                this.showMessageModal(item)
            },
            loaderBarTag(tag) {
                this.showProgressBar(tag)
            }
        },
        components: {
            languageSwitcher,
            customModalDialog,
            pageLoader
        },

        async mounted() {
            await this.fetchSocialList()
        },

        methods: {
            ...mapActions({
                returnToOriginalAccount: 'auth/returnToOriginalAccount',
                fetchSocialList: 'auth/fetchSocialList',
            }),

            onReturnToOriginalAccount() {
                console.log('remove')
                this.customModalSettings = {
                    message: this.translate('admin_ReturnToOriginalAccount', [this.getOriginalCredentials.name]),
                    onOkHandler: this.returnToOriginalAccountAction.bind(null),
                    showCancelButton: true,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }
            },
            async returnToOriginalAccountAction() {
                try {
                    this.customModalSettings = {}
                    await this.returnToOriginalAccount()
                    this.$router.push({name: 'adminPanel'})
                } catch (e) {
                    console.log(`error1:`, e)
                    this.showErrorModal(e.data.error.message)
                }
            },

            showMessageModal(item) {
                let time = new Date().getMilliseconds()
                let duration = item.duration || 15000
                this.messageModalModel = {
                    text: item.msg,
                    displayed: time,
                }
                if (duration > 0) {
                    this.messageModalModel.timer = setTimeout(() => {
                        if (this.messageModalModel && this.messageModalModel.displayed === time) {
                            this.messageModalModel = null
                        }
                    }, duration)
                }
            },
            showProgressBar(data) {
                if (data.show) {
                    this.loaderTags.push(data.tag)
                } else {
                    this.loaderTags = this.loaderTags.filter(item => item != data.tag)
                }
                this.showLoader = this.loaderTags.length > 0
            }
        }

    }

    window.mixin = {
        data() {
            return {
                domain: '',
                checkTextAreaRowsValue: '',
                loadingFacebookSpinner: false
            }
        },
        components: {
            // facebookLogin,
            VFacebookLogin,
            'gmap-custom-marker': GmapCustomMarker
        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo
            }),

            ...mapGetters({
                isUserClient: 'auth/isUserClient',
                isUserOwner: 'auth/isUserOwner',
                isUserAdmin: 'auth/isUserAdmin',
                isUserOrgManager: 'auth/isUserOrgManager',
                isUserSiteManager: 'auth/isUserSiteManager',
            }),
        },

        mounted() {
            console.log(`kek lol kik`)
            const header = document.querySelector('.navbar')
            let isRefreshing = false;
            var refreshReq = ""
            let subscribers = [];
            let refreshErrorSubscribers = [];

            window.addEventListener('scroll', function () {
                if (header) {
                    if (pageYOffset >= 200) {
                        header.classList.add('waypoint-bg')
                    } else {
                        header.classList.remove('waypoint-bg')
                    }
                }
            });

            function subscribeTokenRefresh(cb) {
                subscribers.push(cb);
            }

            function onRrefreshed(token, isAnon) {
                subscribers.map(cb => cb(token, isAnon));
            }

            axios.interceptors.response.use(
                (response) => {
                    return response;
                },
                (error) => {
                    const originalRequest = error.config;
                    console.info('INTRECEPT axios.interceptors.response. error.url:' + originalRequest.url);
                    if (error.response.status === 401 && !isRefreshing) {
                        console.log('DATA___', error.response.data)
                        if(error.response.data.error.code == 1007) {
                            this.mainLogout()
                        }
                        return Promise.reject(error);
                    }
                    if (error.response.status === 403 && !isRefreshing) {
                        isRefreshing = true;
                        console.info('INTRECEPT isRefreshing = true');
                        if (!localStorage.getItem('refresh_token')) {
                            //refresh token not found -> Proceed with anon signin/signup
                            console.info('refresh_token not found');
                            if(error.response.data.error.code == 999) {
                                //got registered token error. anon token not applicable
                                //todo log???
                                return Promise.reject(error);
                            }
                            if (localStorage.getItem('guid')) {
                                //anon guid found -> procced with anon token refresh (anon signin)
                                console.info('guid found');
                                refreshReq = '/auth/sign-in'
                                api.request('post', '/auth/sign-in', {
                                    guid: localStorage.getItem('guid'),
                                })
                                    .then((response) => {
                                        console.log(response.data);
                                        console.info('INTRECEPT ANON SIGNIN success');

                                        this.saveAnonTokenData(response.data)
                                        refreshReq = ''
                                        isRefreshing = false;
                                        console.info('INTRECEPT isRefreshing = false');
                                        onRrefreshed(response.data.anonymous_token, true);
                                        subscribers = [];

                                        // originalRequest.headers.Authorization = 'Bearer ' + response.data.anonymous_token;
                                        // return axios(originalRequest);
                                    })
                                    .catch((error) => {
                                        console.info('INTRECEPT ANON SIGNIN ERROR');
                                        console.log(error);
                                        refreshReq = ''
                                        isRefreshing = false;
                                        refreshReq = '/auth/sign-up'
                                        api.request("post", '/auth/sign-up')
                                            .then((response) => {
                                                console.info('INTRECEPT ANON SIGNUP AFTER ANON SIGNIN ERROR 2 OK_NEW');
                                                console.log(response.data);

                                                this.saveAnonTokenData(response.data)
                                                refreshReq = ''
                                                isRefreshing = false;
                                                if (!originalRequest.url.includes('auth/')
                                                    && !originalRequest.url.includes('/questions') // api/v1/questions && api/questions
                                                    && !originalRequest.url.includes('users') // api/users /users
                                                ) {
                                                    console.info('INTRECEPT to sign-in url:' + originalRequest.url);
                                                    subscribers = [];
                                                    this.$router.push('/sign-in');
                                                    return Promise.reject(error);
                                                }
                                                console.info('INTRECEPT isRefreshing = false');
                                                onRrefreshed(response.data.anonymous_token, true);
                                                subscribers = [];

                                                // originalRequest.headers.Authorization = 'Bearer ' + response.data.anonymous_token;
                                                // return axios(originalRequest);
                                            })
                                            .catch((error) => {
                                                onRrefreshed(null, null);
                                                refreshReq = ''
                                                isRefreshing = false;
                                                subscribers = [];
                                                console.info('INTRECEPT isRefreshing = false');
                                                console.info('INTRECEPT ANON SIGNUP AFTER ANON SIGNIN ERROR 2 ERROR');
                                                console.log(error);
                                            });
                                        console.info('INTRECEPT isRefreshing = false');
                                    });
                            } else {
                                //anon guid not found -> procced with anon signup
                                console.info('guid not found');
                                refreshReq = '/auth/sign-up'
                                api.request("post", '/auth/sign-up')
                                    .then((response) => {
                                        console.info('INTRECEPT ANON SIGNUP OK_NEW');
                                        console.log(response.data);

                                        this.saveAnonTokenData(response.data)
                                        refreshReq = ''
                                        isRefreshing = false;
                                        console.info('INTRECEPT isRefreshing = false');
                                        onRrefreshed(response.data.anonymous_token, true);
                                        subscribers = [];
                                    })
                                    .catch((error) => {
                                        console.info('INTRECEPT ANON SIGNUP ERROR');
                                        console.log(error);
                                        onRrefreshed(null, null);
                                        refreshReq = ''
                                        isRefreshing = false;
                                        console.info('INTRECEPT isRefreshing = false');
                                    });
                            }
                        } else {
                            //refresh token not found -> Proceed with token refresh
                            console.info(`refresh_token found  window.domain:${window.domain}`);
                            if(error.response.data.error.code == 998) {
                                //got anon token error. registered token not applicable
                                return Promise.reject(error);
                            }
                            refreshReq = '/auth/refresh'
                            api.request("post", '/auth/refresh', {
                                token: localStorage.getItem('refresh_token'),
                            })
                                .then((response) => {
                                    console.info('REFRESH OK_NEW');
                                    console.info(response.data);
                                    if (response.data.access_token) {
                                        localStorage.setItem('access_token', response.data.access_token);
                                    }
                                    if (response.data.refresh_token) {
                                        localStorage.setItem('refresh_token', response.data.refresh_token);
                                        localStorage.setItem('user_guid', response.data.user_guid);
                                    }
                                    refreshReq = ''
                                    isRefreshing = false;
                                    console.info('INTRECEPT isRefreshing = false');
                                    onRrefreshed(response.data.access_token, false);
                                    subscribers = [];
                                })
                                .catch((error) => {
                                    console.info('/auth/refresh ERROR');
                                    console.log(error);
                                    this.$store.commit('auth/removeKeys')
                                    refreshReq = '/auth/sign-up'
                                    api.request("post", '/auth/sign-up')
                                        .then((response) => {
                                            console.info('INTRECEPT ANON SIGNUP 2 OK_NEW');
                                            console.log(response.data);

                                            this.saveAnonTokenData(response.data)
                                            refreshReq = ''
                                            isRefreshing = false;
                                            if (!originalRequest.url.includes('auth/')
                                                && !originalRequest.url.includes('/questions') // api/v1/questions && api/questions
                                                && !originalRequest.url.includes('users') // api/users /users
                                            ) {
                                                console.info('INTRECEPT to sign-in url:' + originalRequest.url);
                                                subscribers = [];
                                                this.$router.push('/sign-in');
                                                return Promise.reject(error);
                                            }
                                            console.info('INTRECEPT isRefreshing = false');
                                            onRrefreshed(response.data.anonymous_token, true);
                                            subscribers = [];
                                        })
                                        .catch((error) => {
                                            onRrefreshed(null, null);
                                            refreshReq = ''
                                            isRefreshing = false;
                                            console.info('INTRECEPT isRefreshing = false');
                                            console.info('INTRECEPT ANON SIGNUP 2 ERROR');
                                            console.log(error);
                                        });
                                });
                        }
                    }
                    console.info(`INTRECEPT error.response.status === ${error.response.status} refreshReq:${refreshReq} url:${originalRequest.url}`);
                    if (error.response.status === 403 && isRefreshing) {
                        console.info('INTRECEPT error.response.status === 403 && isRefreshing');
                    }
                    if (originalRequest.url.includes(refreshReq) && refreshReq != "") {
                        console.log('INTRECEPT reject error')
                        return Promise.reject(error);
                    }
                    if (error.response.status === 403) {
                        return new Promise((resolve, reject) => {
                            subscribeTokenRefresh((token, isAnon) => {
                                console.info(`INTRECEPT subscribeTokenRefresh isAnon:${isAnon} token:${token}`);
                                if (token == null) {
                                    reject(new Error())
                                    return
                                } else if (isAnon) {
                                    console.log(`kek lol? originalRequest.url: ${originalRequest.url}`)
                                    if (originalRequest.url.includes('users/')
                                        || (originalRequest.url.includes('v1/questions/') && originalRequest.url.includes('/info'))) { //question manage
                                        reject(new Error())
                                        return
                                    }
                                    console.log(`kek lol? 3`)
                                    if (originalRequest.url.includes('v1/')) {
                                        let oldUrl = originalRequest.url;
                                        originalRequest.url = originalRequest.url.replace('v1/', '');
                                        console.info(`INTRECEPT changedUrl old:${oldUrl} new: ${originalRequest.url}`);
                                    }
                                }
                                originalRequest.headers.Authorization = `Bearer ${token}`;
                                resolve(axios(originalRequest));
                            });
                        });
                    }
                    console.log('INTRECEPT reject error default')
                    return Promise.reject(error);
                }
            );

            if (localStorage.getItem('guid') == undefined || localStorage.getItem('anonymous_token') == undefined) {
                // this.signUpAnon();
            }

            // console.log(this.$gAuth)

            if (localStorage.getItem('access_token') && localStorage.getItem('user_guid')) {
                this.getUserInfo();
            }
            var textarea = document.getElementsByClassName('max-row-2');
            if (textarea.length != 0) {
                textarea[0].onkeyup = function (e) {
                    if (e.keyCode == '13') {
                        console.log(textarea[0].value)
                        if (this.checkTextAreaRowsValue == undefined) {
                            this.checkTextAreaRowsValue = textarea[0].value;
                        }
                        if (textarea[0].value.split('\n').length >= 3) {
                            if (this.checkTextAreaRowsValue.split('\n').length > 2) {
                                textarea[0].value = this.checkTextAreaRowsValue[0] + '\n' + this.checkTextAreaRowsValue[1];
                                this.checkTextAreaRowsValue = textarea[0].value;
                            } else {
                                textarea[0].value = this.checkTextAreaRowsValue;
                            }
                        } else {
                            this.checkTextAreaRowsValue = textarea[0].value;
                        }
                    } else {
                        this.checkTextAreaRowsValue = textarea[0].value;
                    }
                }
            }
        },
        methods: {
            ...mapActions({
                signUpFaceBookAction: 'auth/signUpFaceBook',
                signUpGoogleAction: 'auth/signUpGoogle',
                signUpGoogleNewAction: 'auth/signUpGoogleNew',
                makeOwnerAction: 'owner/makeOwner',
                fetchUserInfo: 'auth/fetchUserInfo'
            }),

            saveAnonTokenData(data) {
                localStorage.setItem("guid", data.guid);
                localStorage.setItem("anonymous_token", data.anonymous_token);
                this.$store.commit('auth/setAnonymousToken', {
                    token: data.anonymous_token,
                    guid: data.guid
                })
            },

            async getUserInfo() {
                await this.fetchUserInfo()
            },

            async tryChangeUserStatus() {
                await this.fetchUserInfo()
                console.log(`zzz this.isUserClient:${this.isUserClient} this.isUserOrgManager:${this.isUserOrgManager} this.isUserSiteManager:${this.isUserSiteManager} this.isUserDriver:${this.isUserDriver}`)
                if(this.isUserDriver) return
                if (this.isUserClient && !this.isUserOrgManager && !this.isUserSiteManager) {
                    await this.makeOwner()
                    await this.fetchUserInfo()
                } else if (this.isUserOwner) {
                    if (this.userInfo.organization) {
                        if (!this.userInfo.organization.place) {
                            this.$store.commit('owner/setOwner', true)
                        }
                    } else {
                        await this.makeOwner()
                        await this.fetchUserInfo()
                    }
                }
            },

            setSignInState(response) {
                console.log(`setSignInState`)
                this.$store.commit('auth/resetAnonymousToken')
                this.$store.commit('auth/setUser', response.data.user_guid)
                this.$store.commit('auth/setAccessToken', {
                    accessToken: response.data.access_token,
                    refreshToken: response.data.refresh_token
                })
            },

            async SignUpFacebook({token, becomeOwner = false, redirect = true}) {
                try {
                    this.signInLoading = true
                    var questionsUids = []
                    var startQText = null
                    try {
                        let json = JSON.parse(localStorage.getItem('login_questions'))
                        questionsUids = json.quids
                        startQText = json.text
                    } catch {
                    }
                    const response = await this.signUpFaceBookAction({token, questionsUids, startQText})
                    if (response.data.access_token && response.data.refresh_token) {
                        this.setSignInState(response)
                        if (becomeOwner) {
                            await this.tryChangeUserStatus()
                        }
                        if (redirect) {
                            this.$router.push({name: 'Login'});
                        }
                    }
                } catch (error) {

                } finally {
                    this.signInLoading = false
                }
            },

            async SignUpGoogle({token, becomeOwner = false, redirect = true, newGoogleCode = null, redirectUri = ""}) {
                try {
                    this.signInLoading = true
                    var questionsUids = []
                    var startQText = null
                    try {
                        let json = JSON.parse(localStorage.getItem('login_questions'))
                        questionsUids = json.quids
                        startQText = json.text
                    } catch {
                    }
                    let response = null
                    if(newGoogleCode) {
                        response = await this.signUpGoogleNewAction({
                            code: newGoogleCode, redirectUri, questionsUids, startQText})
                    } else {
                        response = await this.signUpGoogleAction({token, questionsUids, startQText})
                    }
                    if (response.data.access_token && response.data.refresh_token) {
                        console.log(`test??:becomeOwner${becomeOwner} | redirect:${redirect}`)
                        this.setSignInState(response)
                        if (becomeOwner) {
                            await this.tryChangeUserStatus()
                        }
                        if (redirect) {
                            this.$router.push({name: 'Login'});
                        }
                    }
                } catch (error) {
                    console.log('error', error)
                } finally {
                    this.signInLoading = false
                }
            },

            facebookSignInPromise() {
                let fb = this.FB
                return new Promise(function (resolve, reject) {
                    fb.login((response) => {
                        if (response.authResponse) {
                            resolve(response.authResponse)
                        } else {
                            reject()
                        }
                    }, {
                        scope: 'email',
                        return_scopes: true
                    });
                })
            },

            async FacebookSignIn({becomeOwner, redirect = true}) {
                let auth = await this.facebookSignInPromise()
                if (auth.accessToken) {
                    await this.SignUpFacebook({
                        token: auth.accessToken,
                        becomeOwner,
                        redirect
                    })
                }
            },
            async GoogleSignIn({becomeOwner, redirect = true}) {
                const rootUrl = `http://accounts.google.com/o/oauth2/v2/auth`;
                let redirectUrl = location.origin + `/auth/google/result`
                const options = {
                    redirect_uri: redirectUrl,
                    client_id: '476870467397-vdhi2d5l3sn458mesgpvrg47cugdjgbf.apps.googleusercontent.com',
                    access_type: 'offline',
                    response_type: 'code',
                    prompt: 'consent',
                    scope: [
                        'https://www.googleapis.com/auth/userinfo.profile',
                        'https://www.googleapis.com/auth/userinfo.email',
                    ].join(' '),
                    state: '/',
                };

                const qs = new URLSearchParams(options);

                let authUrl = `${rootUrl}?${qs.toString()}`;
                console.log(`authUrl:`, authUrl)
                window.open(authUrl, '_blank')

                this.signInLoading = true

                await this.getTimerDelay()
                let googleCode = localStorage.getItem('google_code')
                console.log(`got google_code:`, googleCode)
                console.log(`got redirectUrl:`, redirectUrl)
                localStorage.removeItem('google_code')

                console.log(`GoogleSignIn:becomeOwner:${becomeOwner} | redirect:${redirect}`)

                await this.SignUpGoogle({
                    token: null,
                    becomeOwner,
                    redirect,
                    newGoogleCode: googleCode,
                    redirectUri: redirectUrl,
                })
            },

            async getTimerDelay() {
                while (localStorage.getItem('google_code') == null) {
                    await this.delay(1000)
                }
            },

            delay(milliseconds){
                return new Promise(resolve => {
                    setTimeout(resolve, milliseconds);
                });
            },

            async makeOwner() {
                try {
                    const response = await this.makeOwnerAction();
                    if (response.data.success) {
                        this.$store.commit('owner/setOwner', true)
                        this.$router.push({name: 'Login'});
                    }
                } catch (error) {
                    if (error.status == 400) {
                        if (error.data.error.code == 1113) {
                            this.$store.commit('owner/setOwner', true)
                            this.$router.push({name: 'Login'});
                        } else if (error.data.success == false) {
                            this.$store.commit('owner/setOwner', false)
                            this.$router.push({name: 'Login'});
                        }
                    }
                }
            },

            sdkLoaded(payload) {
                this.isConnected = payload.isConnected;
                this.FB = payload.FB;
                this.loadingFacebookSpinner = true;
            },

            back() {
                this.$router.go(-1);
            },

            async reCaptcha(action) {
                await this.$recaptchaLoaded()
                return await this.$recaptcha(action)
            },
            isClickOutOfBlock(blockId, target) {
                return document.getElementById(blockId) == null || !document.getElementById(blockId).contains(target)
            },

            async mainLogout(navToSignIn = true) {
                try {
                    // await this.logoutRemote()
                } catch (error) {
                    console.log('error', error)
                } finally {
                    this.$store.commit('auth/removeKeys')
                    this.$store.commit('owner/setOwner', false)
                    if(navToSignIn) this.$router.push('/sign-in')
                }
            },
        }
    };

    window.auth = {}

</script>

<style>

    /* font converted using font-converter.net. thank you! */
    @import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,700,900&display=swap&subset=cyrillic');
    @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600;700;800;900&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@300;400;500;700&display=swap');


    * {
        font-family: 'Nunito';
        font-weight: 700;
    }

    .md-theme-default body {
        font-size: 1em;
    }

    body b {
        font-weight: 700;
    }

    /*.re-btn {*/
    /*    border-radius: 4px;*/
    /*    background-color: #2F2F2F;*/
    /*    padding: 12px 16px;*/
    /*    border: 2px solid #2f2f2f;*/
    /*    color: #fff;*/
    /*    margin-right: 8px;*/
    /*}*/
    /*.re-btn:last-child {*/
    /*    margin-right: 0;*/
    /*}*/

    /*.re-btn.reverse {*/
    /*    background: none;*/
    /*    border: 2px solid #2F2F2F;*/
    /*    color: #2F2F2F;*/
    /*}*/

    /*.re-btn img {*/
    /*    margin-right: 8px;*/
    /*}*/


    /*.re-btn span {*/
    /*    font-weight: 600;*/
    /*    font-size: 14px;*/
    /*    line-height: 18px;*/
    /*}*/


    .active-field {

    }

    .active-field label {
        margin-right: 33px;
        padding-top: 4px;
    }


    .md-field .md-count,
    .md-field .md-error,
    .md-field .md-helper-text {
        color: #6D6D6D;
    }

    body .custom-checkbox .custom-control-label::before {
        width: 20px;
        height: 20px;
        padding-top: 3px;
    }

    body .custom-control-input:checked ~ .custom-control-label::before {
        border-color: #3F405C;
        background-color: #3F405C;
    }

    .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
        border-color: rgba(47, 47, 47, 0.45);
        background-color: rgba(47, 47, 47, 0.45);
    }

    .custom-control-input:focus ~ .custom-control-label::before {
        box-shadow: 0 0 0 0.2rem rgba(47, 47, 47, 0.25);
    }

    body .custom-control-label::after {
        width: 20px;
        height: 20px;
    }

    .bm-overlay,
    #app {
        background: #fff;
        min-height: auto;
    }

    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        /*color: rgb(50, 110, 234);*/
        color: #b8b7ad;
    }

    .bm-cross-button {
        height: 1.5em;
        width: 1.5em;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .bm-cross-button.cross-style {
        right: .5em;
        top: 0.7em;
    }

    .bm-cross-button.cross-style .bm-cross {
        width: 0.2em;
        height: 1.5em;
    }

    body .bm-burger-button {
        cursor: pointer;
        height: 1em;
        left: 1em;
        position: absolute;
        top: 50%;
        width: 1.5em;
        transform: translateY(-50%);
    }

    .place-preview .bottom .you-vote,
    .place-preview .bottom .users-vote {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #F3F3F3;
        padding: .2em 0.6em .4em;
        border-radius: .25em;
        text-align: center;
    }

    .router-link-active:focus {
        color: #fff;
    }

    .router-link-active {
        color: rgb(50, 110, 234);
    }

    nav.navbar {
        text-align: center;
        height: 4em;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #2F2F2F !important;
        /*background: linear-gradient(to bottom, #18336a, #654DB9);*/
    }

    .bm-item-list {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .face-container-add {
        min-height: 100vh;
        position: fixed;
        z-index: 100;
    }

    .bm-item-list .top {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        padding: 0;
        height: 100%;
    }

    .bm-item-list .top > * {
        padding: .7em;
        min-width: 250px;
        text-align: left;
    }

    .bm-item-list .top > span {
        margin: 0;
    }

    .bm-item-list .logout {
        padding-top: 1em;
        padding-bottom: 1.25em;
        position: relative;
    }

    .bm-item-list .logout:after {
        content: '';
        position: absolute;
        top: 0;
        left: -2em;
        right: 0;
        height: 2px;
        width: calc(100% + 2em);
        background: #585858;
    }

    @media screen and (min-width: 1000px) {
        .navbar {
            justify-content: space-between;
        }

        .navbar > * {
            cursor: pointer;
        }
    }

    /*.change_language,*/
    /*.change_language li {*/
    /*background-size: contain;*/
    /*background-position: center;*/
    /*height: 2em;*/
    /*width: 2em;*/
    /*cursor: pointer;*/
    /*}*/

    /*.change_language {*/
    /*position: fixed;*/
    /*bottom: 1em;*/
    /*left: 1em;*/
    /*margin: 0;*/
    /*z-index: 99;*/
    /*}*/

    /*.change_language li {*/
    /*text-transform: capitalize;*/
    /*position: absolute;*/
    /*margin: 0;*/
    /*transition: all .5s ease-in-out;*/
    /*color: transparent;*/
    /*}*/

    /*.change_language li:first-child {*/
    /*left: 0;*/
    /*}*/

    /*.change_language li:nth-child(2) {*/
    /*left: 3em;*/
    /*}*/

    /*.change_language li:nth-child(3) {*/
    /*left: 6em;*/
    /*}*/

    /*.change_language:not(.active) li {*/
    /*left: -5em !important;*/
    /*}*/

    body .bm-burger-button {
        cursor: pointer;
        height: 18px;
        left: 18px;
        position: absolute;
        top: 50%;
        width: 22px;
        transform: translateY(-50%);
    }

    body .bm-burger-button .line-style {
        height: 1px;
    }

    .bm-burger-button .bm-burger-bars {
        background: #fff;
    }

    .buttons-panel {
        position: fixed;
        bottom: 1em;
        left: 50%;
        transform: translateX(-50%);
        width: 90%;
    }

    @media screen and (min-width: 1000px) {
        .buttons-panel {
            width: 30%;
        }
    }

    .face-container-add {
        min-height: 100vh;
        position: fixed;
    }


    /*Place Global*/
    nav.navbar.fixed {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 9;
    }

    .place-preview {
        width: 100%;
        margin: 0;
    }

    .place-preview .top {
        display: flex;
        flex-direction: row;
    }

    .place-preview .top .image {
        width: 5em;
        height: 5em;
        margin-right: 1em;
        border-radius: 4px;
        overflow: hidden;
        /*box-shadow: 0px 0px 0px 6px #fff, 0px 0px 7px 3px #555;*/
        background-image: url('assets/re/default_place_img.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: left;
    }

    .place-preview .top .image img {
        margin: 0 auto;
        display: block;
        width: 100%;
        height: 100%;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }

    .place-preview .top .address {
        width: calc(100% - 6em);
    }

    .place-preview .top .address a {
        font-weight: bold;
        color: #000;
        font-weight: 700;
    }

    .place-preview .top .address a:hover {
        text-decoration: underline;
        cursor: pointer;
    }

    .place-preview .top .address address {
        margin: 0;
        font-size: 0.8em;
    }

    .place-preview .bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 1em;
    }

    .place-preview .bottom .you-vote {
        width: 5em;
    }

    .place-preview .bottom .you-vote,
    .place-preview .bottom .users-vote {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #F3F3F3;
        padding: .2em 0.6em .5em;
        border-radius: .25em;
    }

    .place-preview .bottom .you-vote span.title,
    .place-preview .bottom .users-vote span.title {
        font-size: 0.7em;
        margin-bottom: .3em;
    }

    .place-preview .bottom .you-vote b {
        font-size: 1em;
        font-weight: bold;
        color: #2F2F2F;
    }

    .place-preview .bottom .users-vote {
        width: calc(100% - 6em);
    }

    .place-preview .bottom .users-vote ul,
    .place-preview .bottom .users-vote ul li {
        display: flex;
        align-items: center;
        margin: 0;
    }

    .place-preview .bottom .users-vote ul {
        display: flex;
        align-items: center;
        margin: 0;
        justify-content: space-between;
        width: 100%;
    }

    .place-preview .bottom .users-vote ul li .image {
        width: 1.5em;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        margin-right: 0.3em;
    }

    .place-preview .bottom .users-vote ul li .image.cool {
        background-color: #36BC00
    }

    .place-preview .bottom .users-vote ul li .image.soso {
        background-color: #FFB000
    }

    .place-preview .bottom .users-vote ul li .image.meh {
        background-color: #EF4300
    }

    .place-preview .bottom .users-vote ul li .image img {
        width: 100%;
        transform: scale(1.4) translateY(1px);
    }

    /*.infinite-status-prompt:nth-child(2) {
        display: none;
    }*/

    .block-spinner,
    .relative-center-block {
        position: absolute;
    }

    .page-spinner {
        position: fixed;
    }

    .block-spinner,
    .page-spinner,
    .relative-center-block {
        z-index: 20;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .relative-center-block {
        width: 90%;
        margin: auto;
        text-align: center;
    }

    .control-panel {
        position: absolute;
        top: 5px;
        right: 5px;
        display: flex;
        transition: all 0.2s ease;
    }

    .place-item .delete-place-icon {
        display: flex;
        cursor: pointer;
    }

    @media screen and (min-width: 1000px) {
        .control-panel,
        .place-item .delete-place-icon {
            display: none;
        }
    }

    .place-item:hover .delete-place-icon {
        display: flex;
    }

    .list-group-item:hover .control-panel {
        display: flex;
    }

    .control-panel-item {
        margin: 5px 8px;
        font-size: 18px;
        cursor: pointer;
    }

    .fa-cog {
        color: #585858;
    }

    .fa-cog:hover {
        color: #2e2e2e;
    }

    .fa-trash-alt {
        color: rgb(224, 93, 41)
    }

    .fa-trash-alt:hover {
        color: rgb(226, 28, 13)
    }

    /* Select */
    .vs__open-indicator {
        cursor: pointer;
    }

    /* Select end */

    .map-marker {
        cursor: pointer;
    }

    .error_modal {
        height: 140px;
        width: 350px;
        z-index: 9999999;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        border-radius: 3px;
        padding: 0;
        background-color: #FFFFFF;
        box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.12);
    }

    .error_modal .body {
        color: #424242;
        position: absolute;
        top: 50%;
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
        text-align: center;
        transform: translate(-0%, -50%);
        white-space: pre-line;
    }

    .error_modal .close {
        position: absolute;
        top: 10px;
        right: 10px;
    }

    .error_modal .close img {
        width: 17px;
        height: 17px;
    }

    .return-to-original-account {
        height: 50px;
        width: 50px;
        background: #0e76a8;
        color: #fff;
        position: fixed;
        bottom: 10px;
        left: 10px;
        border-radius: 25px;
        transition: all .3s linear;
        padding: 0;
    }

    .return-to-original-account * {
        transition: width .3s linear;
    }

    .return-to-original-account:hover div {
        width: 100%;
        display: flex;
    }

    .return-to-original-account i {
        position: absolute;
        top: 25px;
        right: 25px;
        transform: translate(50%, -50%);
        pointer-events: none;
    }

    .return-to-original-account .text {
        overflow: hidden;
        white-space: nowrap;
        margin: 0;
        width: 50px;
        opacity: 0;
        pointer-events: none;
    }

    .return-to-original-account:hover {
        width: unset;
        padding-right: 40px;
        padding-left: 15px;
    }

    .return-to-original-account:hover .text {
        width: 100%;
        opacity: 1;
    }

    .return-to-original-account:hover i {
        right: 25px;
    }
    @media screen and (max-width: 475px) {
        .active-field label {
            width: 100% !important;
        }

        nav.navbar {
            height: auto;
        }
        .nav-tabs .nav-link {
            border: none !important;
            padding: 3px;
        }
    }

</style>
